'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$33() {
  this.ayr = null;
  this.ayp = null;
  this.ayq = false;
  this.ayn = null;
  this.ayo = false;
  this.ays = false;
  this.ayt = false;
  this.ayr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$33 as $c_Lpresto_AgentView$$anon$33 };
$p = $c_Lpresto_AgentView$$anon$33.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$33;
/** @constructor */
function $h_Lpresto_AgentView$$anon$33() {
}
export { $h_Lpresto_AgentView$$anon$33 as $h_Lpresto_AgentView$$anon$33 };
$h_Lpresto_AgentView$$anon$33.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.ayr;
});
$p.t = (function() {
  if ((!this.ayq)) {
    this.ayp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayq = true;
  }
  return this.ayp;
});
$p.ad = (function() {
  if ((!this.ayo)) {
    this.ayn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().p9(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayo = true;
  }
  return this.ayn;
});
$p.v = (function() {
  if ((!this.ayt)) {
    this.ays = false;
    this.ayt = true;
  }
  return this.ays;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$33 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$33, "presto.AgentView$$anon$33", ({
  DV: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$33 as $d_Lpresto_AgentView$$anon$33 };
//# sourceMappingURL=presto.-Agent-View$$anon$33.js.map
